import { api } from '../api/http-service'
import { getEntitlements } from '../api/internal/entitlements'
import { deleteUser, getUsersWithRolesList, inviteUser, updateUserAndRoles } from '../api/internal/users'
import {
  createPersonalAccessToken,
  deletePersonalAccessToken,
  listPersonalAccessTokens,
} from '../api/internal/personalAccessTokens'
import { createAgent, deleteAgent, getAgentVersions, listAgents, revertToVersion } from '../api/overrides/agents'
import { createAutoBuild } from '../api/overrides/autobuild'
import { getAgentLogs, getEnvironmentLogs, getLogByCompoundKey } from '../api/overrides/logs'
import { getMappingFamilies, getMappingSessions } from '../api/overrides/mapping'
import { updateSpaces } from '../api/overrides/spaces'
import { getSessions } from '../api/overrides/sessions'
import { updateOnboardingProgress } from '../api/internal/onboardings'
import { bind } from '../utils/bind'

export const ResourceMap = {
  ACCOUNTS: {
    shorthand: 'ac',
    list: async (..._args: any) => null, // Placeholder
    get: bind(api.accounts, 'getCurrent'),
    create: async (..._args: any) => null, // Placeholder
    update: bind(api.accounts, 'updateCurrent'),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  SPACES: {
    shorthand: 'sp',
    list: getSessions,
    get: bind(api.spaces, 'get'),
    create: bind(api.spaces, 'create'),
    update: bind(api.spaces, 'update'),
    upgrade: bind(api.spaces, 'upgrade'),
    delete: bind(api.spaces, 'delete'),
    bulkDelete: bind(api.spaces, 'bulkDelete'),
    bulkUpdate: updateSpaces,
    archive: bind(api.spaces, 'archiveSpace'),
  },
  ENVIRONMENTS: {
    shorthand: 'env',
    list: bind(api.environments, 'list'),
    get: bind(api.environments, 'get'),
    create: bind(api.environments, 'create'),
    update: bind(api.environments, 'update'),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  JOBS: {
    shorthand: 'jb',
    list: bind(api.jobs, 'list'),
    get: bind(api.jobs, 'get'),
    create: bind(api.jobs, 'create'),
    update: bind(api.jobs, 'update'),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  MAPPING_PROGRAMS: {
    shorthand: 'mp',
    list: getMappingSessions,
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  MAPPING_FAMILIES: {
    shorthand: 'mf',
    list: getMappingFamilies,
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  DATA_RETENTION_POLICIES: {
    shorthand: 'drp',
    list: bind(api.dataRetentionPolicies, 'list'),
    get: bind(api.dataRetentionPolicies, 'get'),
    create: bind(api.dataRetentionPolicies, 'create'),
    update: bind(api.dataRetentionPolicies, 'update'),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  APPS: {
    shorthand: 'app',
    list: bind(api.apps, 'list'),
    get: bind(api.apps, 'get'),
    create: bind(api.apps, 'create'),
    update: bind(api.apps, 'update'),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: bind(api.apps, 'delete'),
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  ENTITLEMENTS: {
    shorthand: 'ent',
    list: getEntitlements,
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  LOGS: {
    shorthand: 'evt',
    list: getEnvironmentLogs,
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  USERS: {
    shorthand: 'usr',
    list: getUsersWithRolesList,
    create: inviteUser,
    update: updateUserAndRoles,
    upgrade: async (..._args: any) => null, // Placeholder
    delete: deleteUser, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  GUESTS: {
    shorthand: 'gst',
    list: bind(api.guests, 'list'),
    get: async (..._args: any) => null, // Placeholder
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  ROLES: {
    shorthand: 'rol',
    list: bind(api.roles, 'list'),
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  AGENTS: {
    shorthand: 'ag',
    list: listAgents,
    get: bind(api.agents, 'get'),
    create: createAgent,
    update: async (..._args: any) => null, // No update as create is upsert
    upgrade: async (..._args: any) => null, // Placeholder
    delete: deleteAgent,
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  AGENT_LOGS: {
    shorthand: 'evt',
    list: getAgentLogs,
    get: getLogByCompoundKey,
    create: async (..._args: any) => null, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  AUTOBUILD: {
    shorthand: 'ab',
    list: async (..._args: any) => null, // Placeholder
    get: async (..._args: any) => null, // Placeholder
    create: createAutoBuild, // Placeholder
    update: async (..._args: any) => null, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  AGENT_VERSIONS: {
    shorthand: 'agv',
    list: getAgentVersions, // Placeholder
    get: async (..._args: any) => null, // Placeholder
    create: async (..._args: any) => null, // Placeholder
    update: revertToVersion, // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  WORKBOOKS: {
    shorthand: 'wb',
    list: bind(api.workbooks, 'list'), // Placeholder
    get: bind(api.workbooks, 'get'), // Placeholder
    create: async (..._args: any) => null, // Placeholder
    update: bind(api.workbooks, 'update'), // Placeholder
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
  PERSONAL_ACCESS_TOKENS: {
    shorthand: 'pat',
    list: listPersonalAccessTokens,
    get: async (id: string) => {
      const tokens = await listPersonalAccessTokens()
      return tokens.data.find((token) => token.id === id) || null
    },
    create: async (data: { name: string }) => createPersonalAccessToken(data.name),
    update: async (..._args: any) => null, // Not supported
    upgrade: async (..._args: any) => null, // Not supported
    delete: deletePersonalAccessToken,
    bulkDelete: async (..._args: any) => null, // Not supported
    bulkUpdate: async (..._args: any) => null, // Not supported
    archive: async (..._args: any) => null, // Not supported
  },
  ONBOARDINGS: {
    shorthand: 'onb',
    list: bind(api.onboardings, 'getOnboardings'),
    get: bind(api.onboardings, 'getOnboarding'),
    create: async (..._args: any) => null, // Placeholder
    update: async (onboardingId: string, updateData: any) => updateOnboardingProgress(onboardingId, updateData),
    upgrade: async (..._args: any) => null, // Placeholder
    delete: async (..._args: any) => null, // Placeholder
    bulkDelete: async (..._args: any) => null, // Placeholder
    bulkUpdate: async (..._args: any) => null, // Placeholder
    archive: async (..._args: any) => null, // Placeholder
  },
} as const

export type ResourceMap = typeof ResourceMap
